import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
import { PRODUCT_LINE_NAME_CODE } from '@ordersnproducts/modules/shared/constants/product-lines-codes';
import { COUNTRY_CODE } from '@cemex-core/cmx-api';

@Injectable()
export class ModifyOrderFeature implements IFlagFeature {
  name = Features.ModifyOrder;

  protected multiItemEnabledCountries = {
    [COUNTRY_CODE.UNITED_KINGDOM]: [PRODUCT_LINE_NAME_CODE.READYMIX],
  };

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    let orderHasItems = params.orderItemSize === 1;

    if (params.countryCode) {
      const enabledBusinessLines = this.multiItemEnabledCountries[params.countryCode];

      if (
        enabledBusinessLines &&
        enabledBusinessLines.length &&
        enabledBusinessLines.includes(params.businessLineCode)
      ) {
        orderHasItems = true;
      }
    }

    if (orderHasItems) {
      if (container[this.name].getValue().split(' ').includes(params.businessLineCode)) {
        return true;
      }

      if (params.businessLineCode === PRODUCT_LINE_NAME_CODE.ADMIXTURES) {
        return container[Features[`ModifyOrder_${params.businessLineCode}`]].isEnabled();
      }
    }

    return false;
  }
}
